import { render, staticRenderFns } from "./AdminRoles.vue?vue&type=template&id=25488c72&"
import script from "./AdminRoles.vue?vue&type=script&lang=js&"
export * from "./AdminRoles.vue?vue&type=script&lang=js&"
import style0 from "./AdminRoles.vue?vue&type=style&index=0&id=25488c72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports